import { Link } from "react-router";
import logoFooterDTA from "@assets/events-awards/dta/logo-footer-dta.png";
import { DTA_FOOTER_MENU_MOBILE } from "@dta/utils/constants";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_DTA_PATH } from "@events-awards/utils/constants";

/**
 * Component to display footer for mobile view in DTA pages
 */
const DTAFooterMobile = (): React.ReactElement => {
  return (
    <div
      className="w-full pb-5 text-center"
      data-testid="dta-footer-mobile-component"
    >
      <div className="mb-12 flex w-full flex-col items-center justify-center">
        <Link to={EVENTS_AWARDS_DTA_PATH} reloadDocument>
          <img
            src={logoFooterDTA}
            alt="Emerging Enterprise Awards logo"
            width={181}
            height={84}
          />
        </Link>
      </div>

      <div>
        <h3 className="mb-2 text-left font-poppins text-base font-semibold tracking-widest">
          About Us
        </h3>

        <div className="text-left text-base text-white">
          <p>
            The Design AI and Tech Awards celebrates innovation across all types
            of enterprises — from startups and SMEs to large corporations — that
            harness design and technology to create impactful solutions for
            real-world business challenges.
          </p>

          <p>
            These awards are designed to recognise and celebrate innovation
            across various businesses sizes and industries.
          </p>
        </div>
      </div>

      <div className="-mx-0 mt-12 flex w-full flex-row">
        <div className="w-1/2">
          <h3 className="mb-3 text-left font-public-sans text-base font-semibold">
            Sections
          </h3>

          <FooterMenuLinks
            items={DTA_FOOTER_MENU_MOBILE.slice(0, 6)}
            className="space-y-4"
          />
        </div>

        <div className="w-1/2 pl-3">
          <h3 className="mb-3 text-left font-public-sans text-base font-semibold">
            Quick Links
          </h3>

          <FooterMenuLinks
            items={DTA_FOOTER_MENU_MOBILE.slice(6, 9)}
            className="space-y-4"
          />
        </div>
      </div>
    </div>
  );
};

export default DTAFooterMobile;
